module.exports = __webpack_public_path__ + "media/Team/Group1-13ad23c4.svg";